// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isRequired = "isRequired",
    isDisabled = "isDisabled",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isRequired]: boolean;
        [fields.isDisabled]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
    firstName: state.greif.components.recommendedProductRequestForm.fieldValues["firstName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface FirstNameStyles {
    firstNameTextField?: TextFieldPresentationProps;
}

export const firstNameStyles: FirstNameStyles = {};

const styles = firstNameStyles;

const FirstName: FC<Props> = ({ fields, session, firstName, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [firstNameErrorMessage, setFirstNameErrorMessage] = useState("");

    const firstNameLabel = translate("First Name");

    useEffect(() => {
        if (session) {
            setFieldValue({ key: "firstName", value: session.firstName });
        }
    }, [session]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.firstName = validateFirstName;
        if (typeof firstName !== "undefined") {
            validateFirstName();
        }
    }, [firstName]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.firstName = validateFirstName;
    }, [isRequired]);

    const validateFirstName = () => {
        const errorMessage = isRequired && !firstName ? siteMessage("Field_Required", firstNameLabel).toString() : "";
        setFirstNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const firstNameChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "firstName", value: event.target.value });
    };

    return (
        <TextField
            {...styles.firstNameTextField}
            label={firstNameLabel}
            value={firstName || ""}
            onChange={firstNameChangeHandler}
            required={isRequired}
            error={firstNameErrorMessage}
            disabled={isDisabled}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(FirstName),
    definition: {
        displayName: "First Name",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
